module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_237_ccso.31fe8977.png";